<template>

  <PunTable />
 
</template>

<script>
import PunTable from '../components/pratiche/TablePun.vue'

export default {
  components: {
    PunTable

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
